import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_URL, BASE_AUTOCOMPLETE_URL, BASE_COMMON_URL } from '../apiConfig';

export const fetchTableColumnValues = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-table-column-values`,
    payload,
  );
  return response;
};

export const fetchCodeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_COMMON_URL}/code-list`,
    payload,
  );
  return response;
};

export const fetchHrCompanyList = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_COMMON_URL}/hr-company-list`,
  );
  return response;
};

export const fetchHRCodeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_COMMON_URL}/hr-code-list`,
    payload,
  );
  return response;
};

export const downloadBlobByPath = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_COMMON_URL}/download-by-path`,
    payload,
    {
      responseType: 'blob',
    },
  );
  return response;
};

export const downloadBlobType = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_COMMON_URL}/download-blob-type`,
    payload,
    {
      responseType: 'blob',
    },
  );
  return response;
};
